
export const ifString = (string, fallbackString) => {
	if (string && string.trim().length) {
		return string
	} else {
		return fallbackString
	}
}